<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12">
        <v-text-field v-model="sosName" label="Họ và tên" dense outlined></v-text-field>
        <v-text-field v-model="sosPhone" label="Số điện thoại" dense outlined></v-text-field>
        <v-text-field dense outlined v-model="sosAddress" label="Địa chỉ"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { get } from 'lodash'

export default {
  props: {
    teacher: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    sosName: '',
    sosPhone: '',
    sosAddress: ''
  }),
  created() {
    this.reset()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.sosName = get(this.teacher, 'metadata.sosName', '')
      this.sosPhone = get(this.teacher, 'metadata.sosPhone', '')
      this.sosAddress = get(this.teacher, 'metadata.sosAddress', '')
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        sosName: this.sosName,
        sosPhone: this.sosPhone,
        sosAddress: this.sosAddress
      }
    }
  },
  watch: {
    teacher(teacher) {
      this.reset()
    }
  }
}
</script>

<style>
input {
  margin: 8px 0px;
}
</style>
